var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_b_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M424.9,268.8c0.2,0.1,0.3,0.1,0.5,0.1c-13.9-13.8-34.1-12-45,4.5c0.2,1,0.6,1.8,1.3,2.2 c14,8,34.5,3.2,44.1-6.5c-0.1-0.1-0.2-0.1-0.3-0.2C425.2,268.9,425.1,268.9,424.9,268.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M391.3,263.2c-0.6,1.3-1,2.8-1,4.3c0,5.7,4.8,10.2,10.7,10.2c5.9,0,10.7-4.6,10.7-10.2 c0-2.9-1.3-5.5-3.3-7.4C402.6,259.2,396.6,260.2,391.3,263.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E59B70",
    d: "M426.9,267.5c0-0.2-0.1-0.4-0.1-0.5C426.9,267.1,426.9,267.3,426.9,267.5c0.1,0.1,0.2,0.2,0.2,0.3 c0.3-2.3-0.3-4.8-1.3-6.7c-0.4-0.7-0.8-1.4-1.3-2.1c-7.1-8.5-17.7-10.7-28.2-6.1c-0.8,0.4-1.6,0.8-2.4,1.2c-2.4,1.3-4.7,3-6.8,5 c-0.6,0.6-1.2,1.2-1.7,1.9c-2.2,2.6-3.9,5.5-4.8,8.7c-0.2,0.9-0.3,1.9-0.3,2.9C389.8,253,413.1,251.9,426.9,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M425.4,269c0.8,0.4,1,0.3,1.3,0.1c0.5-0.3,0.6-1.1,0.3-1.6c-13.9-15.6-37.1-14.5-46.7,5 c0,0.2,0,0.4,0,0.6c0,0.1,0.1,0.3,0.1,0.4C391.3,257,411.5,255.2,425.4,269z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#271710",
    cx: 400.7,
    cy: 267.6,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 402.3,
    cy: 267,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F2F2ED",
    cx: 396,
    cy: 271.5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M289.7,268.8c-0.2,0.1-0.3,0.1-0.5,0.1c13.9-13.8,34.1-12,45,4.5c-0.2,1-0.6,1.8-1.3,2.2 c-14,8-34.5,3.2-44.1-6.5c0.1-0.1,0.2-0.1,0.3-0.2C289.4,268.9,289.5,268.9,289.7,268.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M323.3,263.2c0.6,1.3,1,2.8,1,4.3c0,5.7-4.8,10.2-10.7,10.2c-5.9,0-10.7-4.6-10.7-10.2 c0-2.9,1.3-5.5,3.3-7.4C312,259.2,318,260.2,323.3,263.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E59B70",
    d: "M287.6,267.5c0-0.2,0.1-0.4,0.1-0.5C287.7,267.1,287.7,267.3,287.6,267.5c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.3-2.3,0.3-4.8,1.3-6.7c0.4-0.7,0.8-1.4,1.3-2.1c7.1-8.5,17.7-10.7,28.2-6.1c0.8,0.4,1.6,0.8,2.4,1.2c2.4,1.3,4.7,3,6.8,5 c0.6,0.6,1.2,1.2,1.7,1.9c2.2,2.6,3.9,5.5,4.8,8.7c0.2,0.9,0.3,1.9,0.3,2.9C324.8,253,301.5,251.9,287.6,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M289.2,269c-0.8,0.4-1,0.3-1.3,0.1c-0.5-0.3-0.6-1.1-0.3-1.6c13.9-15.6,37.1-14.5,46.7,5 c0,0.2,0,0.4,0,0.6c0,0.1-0.1,0.3-0.1,0.4C323.3,257,303.1,255.2,289.2,269z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#271710",
    cx: 313.8,
    cy: 267.6,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 312.3,
    cy: 267,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F2F2ED",
    cx: 318.5,
    cy: 271.5,
    r: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape1B);
export default __webpack_public_path__ + "static/media/eyeshape_1b.3bdedc35aee0c858b44b1f1a960a3b36.svg";
export { ForwardRef as ReactComponent };